import { Auth } from '@/utils';
import { base } from '../../utils';

export const deleteUser = async (id) => {
  const token = await Auth.getIdToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const { data } = await base.delete(`/v1/users/${id}`, { headers });

    return data;
  } catch (error) {
    throw new Error(error);
  }
};
